export default __webpack_public_path__ + "static/media/russian poker-07.81378e5f.png";